import basketballData from "../../data/basketballData";
import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const BasketballCourt = () => {
  return (
    <>
      <ServiceHero data={basketballData} />

      <ServiceOverview data={basketballData} />

      <ServiceBenefits data={basketballData} />

      <ConstructionProcess />

      <TechnicalSpecs data={basketballData} />

      <ServiceGallery data={basketballData} />

      <WhyChooseService data={basketballData} />

      <ServiceFAQ faqs={basketballData.faqs} />

      <RelatedServices data={basketballData} />

      <ServiceCTA data={basketballData} />
    </>
  );
};

export default BasketballCourt;
